import React from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

const LoadingTable = () => {
  return (
    <Box sx={{ width: "100%", padding: 5 }}>
      <Box display="flex">
        <Box sx={{ flex: 1 }}>
          <Skeleton height={40} />
          <Skeleton height={40} />
          <Skeleton height={40} />
        </Box>
        <Box sx={{ flex: 6, paddingLeft: 2 }}>
          <Skeleton height={40} />
          <Skeleton height={40} />
          <Skeleton height={40} />
        </Box>
      </Box>
      <Skeleton variant="rounded" sx={{ marginBottom: "10px" }} height={40} />
      <Skeleton variant="rounded" sx={{ marginBottom: "10px" }} height={40} />
      <Skeleton variant="rounded" sx={{ marginBottom: "10px" }} height={40} />
      <Skeleton variant="rounded" sx={{ marginBottom: "10px" }} height={40} />
      <Skeleton variant="rounded" sx={{ marginBottom: "10px" }} height={40} />
    </Box>
  );
};

export default LoadingTable;
